import React from "react";

function AccountDeletionPolicy() {
  return (
    <div
      className="col-xl-12 mx-xl-auto"
      style={{
        padding: "20px",
        backgroundColor: "white",
        marginLeft: "80px" 
      }}
    >
      <div className="card card-raised mb-3">
        <div className="card-body p-4">

          {/* Header */}
          <div
            style={{
              backgroundColor: "#2e7fae",
              color: "white",
              padding: "15px",
              textAlign: "center",
              position: "relative",
              border: "2px solid white",
              marginBottom: "20px",
            }}
          >
            <img
              src="/careconnect.jpg"
              alt="Logo"
              style={{
                height: "50px",
                position: "absolute",
                left: "20px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
            <h2 style={{ margin: 0 }}>Account Deletion Policy</h2>
          </div>

          {/* Content */}
          <div style={{ lineHeight: "1.7" }}>

            <h4>1. Patient Profile Deletion</h4>
            <p>
              The Care Coordinator has permission to remove patient profiles from the system.
            </p>

            <ul style={{ marginLeft: "40px" }}>
              <li>Login to the application using <b>Care Coordinator credentials</b>.</li>
              <li>Navigate to the <b>Patient Profile</b> section.</li>
              <li>View the list of registered patients.</li>
              <li>Select the patient profile you want to delete.</li>
              <li>Click the <b>Delete</b> button.</li>
              <li>Confirm the deletion.</li>
              <li>The selected patient profile will be removed from the system.</li>
            </ul>

            <h4>2. Doctor Profile Deletion</h4>
            <p>
              Doctor profiles can also be removed by the Care Coordinator when required.
            </p>

            <ul style={{ marginLeft: "40px" }}>
              <li>Login to the application using <b>Care Coordinator credentials</b>.</li>
              <li>Navigate to the <b>Doctor Profile</b> section.</li>
              <li>Select the doctor profile you want to delete.</li>
              <li>Click the <b>Delete</b> option.</li>
              <li>Confirm the deletion.</li>
              <li>The doctor profile will be deleted from the system.</li>
            </ul>

            <h4>3. Important Note</h4>
            <p>
              Account deletion is a permanent action and cannot be undone.
              Only authorized users with proper access rights are allowed to perform profile deletions.
            </p>

            <h4>4. Contact Support</h4>
            <p>
              If you need assistance with account deletion, please contact our support team at:
              <br />
              <b>support@careconnect</b>
            </p>

          </div>

        </div>
      </div>
    </div>
  );
}

export default AccountDeletionPolicy;